import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setCurrentPage = (pageIndex: string) => store.dispatch(appActions.setCurrentPage(pageIndex));

export default setCurrentPage;
